import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import pt from "./locales/pt/translation.json";
import es from "./locales/es/translation.json";
import zh from "./locales/zh/translation.json";

const userLang =
  typeof navigator !== "undefined"
    ? navigator.language?.toLowerCase().startsWith("pt")
      ? "pt"
      : navigator.language?.toLowerCase().startsWith("es")
      ? "es"
      : navigator.language?.toLowerCase().startsWith("zh")
      ? "zh"
      : "en"
    : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
    es: { translation: es },
    zh: { translation: zh },
  },
  lng: userLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;